exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".moving-arrow[data-v-54b19cf3]{border-right:17px solid #f4f3ef;border-top:17px solid transparent;border-bottom:17px solid transparent;display:inline-block;position:absolute;left:243px;top:95px;transition:all .5s cubic-bezier(.29,1.42,.79,1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54b19cf3","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?data=@import "./src/scss/base";!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/engagement/common/sidebar/MovingArrow.vue
// module id = 816
// module chunks = 1